import colors from '_containers/Theme/corporate/colors';

export default {
  lightBanner: {
    color: colors.text.default,
    headerColor: colors.background.darkBlue,
  },
  darkBanner: {
    color: colors.text.dark.default,
    headerColor: colors.background.tint1,
  },
  background: {
    black: colors.element.neutralBlack,
    blue: colors.element.primary,
    orange: colors.brand.orange.secondary,
    purple: colors.element.secondary,
    teal: colors.featureList.tick,
    yellow: colors.element.primary2,
  }, 
  border: {
    color: colors.ui.divider
  }, 
  icon: {
    color: colors.all.brandPrimary1
  }
};
